import Card from "../../../../common/element/Card";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import DoughnutChart from "../../../../common/chart/Doughnut";
import { useNavigate } from "react-router-dom";
const TotalClientAndWorker = ({ chartData, title,redirectPath }) => {
  const navigate = useNavigate();
  return (
    <Card className="py-6 border border-gray-200 rounded-xl dark-shadow">
      <div className="px-6">
        <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-3">
          <div className="flex items-center">
            <span className="mr-4">
              {title == "Clients" ?
                (<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M18.818 4.84647L18.818 4.84648C19.2151 4.91279 19.5063 5.2563 19.5063 5.65874V18.6823C19.5063 19.1371 19.1378 19.5058 18.6828 19.5058H12.8945C12.4399 19.5058 12.0711 19.1367 12.0711 18.6823C12.0711 18.2278 12.4399 17.8587 12.8945 17.8587H17.8595L17.8594 6.35648L10.8239 5.18397V18.6823C10.8239 19.1367 10.4552 19.5058 10.0004 19.5058C9.54578 19.5058 9.17711 19.1367 9.17711 18.6823V4.21176C9.17711 3.96961 9.28347 3.73994 9.46818 3.58353C9.65279 3.42699 9.89717 3.3597 10.1357 3.39948C10.1357 3.39948 10.1357 3.39948 10.1357 3.39948L18.818 4.84647Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M12.0706 15.0645C12.0706 14.6095 12.4391 14.2411 12.894 14.2411H15.7882C16.2432 14.2411 16.6117 14.6095 16.6117 15.0645V18.6821C16.6117 19.1371 16.2432 19.5057 15.7882 19.5057H12.894C12.4391 19.5057 12.0706 19.1371 12.0706 18.6821V15.0645ZM13.7176 17.8586H14.9647V15.8881H13.7176V17.8586Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M3.39091 15.0645C3.39091 14.6095 3.75953 14.2411 4.21446 14.2411H7.1086C7.56355 14.2411 7.93203 14.6095 7.93203 15.0645V18.6821C7.93203 19.1371 7.56357 19.5057 7.1086 19.5057H4.21446C3.75951 19.5057 3.39091 19.1371 3.39091 18.6821V15.0645ZM5.03805 17.8586H6.28504V15.8881H5.03805V17.8586Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M1.45215 0.505087L1.45226 0.505104L10.1345 1.95234C10.5315 2.01852 10.8227 2.36194 10.8227 2.76461V18.6821C10.8227 19.1369 10.4543 19.5056 9.99922 19.5056H4.21095C3.75633 19.5056 3.38764 19.1364 3.38764 18.6821C3.38764 18.2278 3.75633 17.8587 4.21095 17.8587H9.17588L9.17595 3.46234L2.14038 2.28959V18.6822C2.14038 19.1365 1.7717 19.5056 1.31707 19.5056C0.862333 19.5056 0.493638 19.1365 0.493638 18.6822V1.31738C0.493638 1.07524 0.600203 0.845855 0.784713 0.689396C0.969401 0.532545 1.21377 0.465607 1.45215 0.505087Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M14.9647 11.0852C14.9647 10.8302 15.1715 10.6234 15.4264 10.6234H16.1499C16.4049 10.6234 16.6117 10.8302 16.6117 11.0852V11.8087C16.6117 12.0636 16.4049 12.2705 16.1499 12.2705H15.4264C15.1715 12.2705 14.9647 12.0636 14.9647 11.8087V11.0852Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M12.0702 11.0852C12.0702 10.8302 12.277 10.6234 12.532 10.6234H13.2554C13.5104 10.6234 13.7172 10.8302 13.7172 11.0852V11.8087C13.7172 12.0636 13.5104 12.2705 13.2554 12.2705H12.532C12.277 12.2705 12.0702 12.0636 12.0702 11.8087V11.0852Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M12.0702 8.1909C12.0702 7.93607 12.277 7.7291 12.532 7.7291H13.2554C13.5104 7.7291 13.7172 7.93606 13.7172 8.1909V8.91445C13.7172 9.16928 13.5104 9.37625 13.2554 9.37625H12.532C12.277 9.37625 12.0702 9.16929 12.0702 8.91445V8.1909Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M14.9647 8.1909C14.9647 7.93609 15.1715 7.7291 15.4264 7.7291H16.1499C16.4049 7.7291 16.6117 7.93606 16.6117 8.1909V8.91445C16.6117 9.16928 16.4049 9.37625 16.1499 9.37625H15.4264C15.1715 9.37625 14.9647 9.16927 14.9647 8.91445V8.1909Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M6.28501 11.0852C6.28501 10.8302 6.49182 10.6234 6.7468 10.6234H7.47036C7.72523 10.6234 7.93203 10.8302 7.93203 11.0852V11.8087C7.93203 12.0635 7.72526 12.2705 7.47036 12.2705H6.7468C6.49182 12.2705 6.28501 12.0636 6.28501 11.8087V11.0852Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M3.39036 11.0852C3.39036 10.8302 3.59717 10.6234 3.85215 10.6234H4.57571C4.83053 10.6234 5.0375 10.8302 5.0375 11.0852V11.8087C5.0375 12.0636 4.83057 12.2705 4.57571 12.2705H3.85215C3.59716 12.2705 3.39036 12.0636 3.39036 11.8087V11.0852Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M3.39036 8.1909C3.39036 7.93607 3.59715 7.7291 3.85215 7.7291H4.57571C4.83055 7.7291 5.0375 7.93603 5.0375 8.1909V8.91445C5.0375 9.1693 4.83057 9.37625 4.57571 9.37625H3.85215C3.59716 9.37625 3.39036 9.16929 3.39036 8.91445V8.1909Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M6.28501 8.1909C6.28501 7.93607 6.4918 7.7291 6.7468 7.7291H7.47036C7.72525 7.7291 7.93203 7.93608 7.93203 8.1909V8.91445C7.93203 9.16925 7.72526 9.37625 7.47036 9.37625H6.7468C6.49182 9.37625 6.28501 9.16929 6.28501 8.91445V8.1909Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M6.28501 5.29685C6.28501 5.04203 6.4918 4.83506 6.7468 4.83506H7.47036C7.72525 4.83506 7.93203 5.04203 7.93203 5.29685V6.02041C7.93203 6.27535 7.72524 6.4822 7.47036 6.4822H6.7468C6.49184 6.4822 6.28501 6.27539 6.28501 6.02041V5.29685Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                  <path
                    d="M3.39036 5.29685C3.39036 5.04203 3.59715 4.83506 3.85215 4.83506H4.57571C4.83055 4.83506 5.0375 5.04199 5.0375 5.29685V6.02041C5.0375 6.2754 4.83055 6.4822 4.57571 6.4822H3.85215C3.59718 6.4822 3.39036 6.27539 3.39036 6.02041V5.29685Z"
                    fill="#101828"
                    stroke="#101828"
                    stroke-width="0.2"
                  />
                </svg>)
                : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M18.818 4.84647L18.818 4.84648C19.2151 4.91279 19.5063 5.2563 19.5063 5.65874V18.6823C19.5063 19.1371 19.1378 19.5058 18.6828 19.5058H12.8945C12.4399 19.5058 12.0711 19.1367 12.0711 18.6823C12.0711 18.2278 12.4399 17.8587 12.8945 17.8587H17.8595L17.8594 6.35648L10.8239 5.18397V18.6823C10.8239 19.1367 10.4552 19.5058 10.0004 19.5058C9.54578 19.5058 9.17711 19.1367 9.17711 18.6823V4.21176C9.17711 3.96961 9.28347 3.73994 9.46818 3.58353C9.65279 3.42699 9.89717 3.3597 10.1357 3.39948C10.1357 3.39948 10.1357 3.39948 10.1357 3.39948L18.818 4.84647Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M12.0716 15.0647C12.0716 14.6098 12.4401 14.2413 12.895 14.2413H15.7891C16.2442 14.2413 16.6127 14.6098 16.6127 15.0647V18.6824C16.6127 19.1373 16.2442 19.5059 15.7891 19.5059H12.895C12.44 19.5059 12.0716 19.1373 12.0716 18.6824V15.0647ZM13.7186 17.8589H14.9657V15.8883H13.7186V17.8589Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.38895 15.0647C3.38895 14.6098 3.75758 14.2413 4.21251 14.2413H7.10664C7.56159 14.2413 7.93008 14.6098 7.93008 15.0647V18.6824C7.93008 19.1373 7.56162 19.5059 7.10664 19.5059H4.21251C3.75756 19.5059 3.38895 19.1373 3.38895 18.6824V15.0647ZM5.0361 17.8589H6.28309V15.8883H5.0361V17.8589Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M1.45411 0.505331L1.45421 0.505348L10.1365 1.95258C10.5335 2.01877 10.8246 2.36218 10.8246 2.76485V18.6824C10.8246 19.1372 10.4563 19.5058 10.0012 19.5058H4.21291C3.75828 19.5058 3.38959 19.1367 3.38959 18.6824C3.38959 18.2281 3.75828 17.8589 4.21291 17.8589H9.17783L9.1779 3.46259L2.14234 2.28983V18.6824C2.14234 19.1367 1.77365 19.5059 1.31903 19.5059C0.864286 19.5059 0.495591 19.1367 0.495591 18.6824V1.31762C0.495591 1.07549 0.602156 0.846099 0.786666 0.68964C0.971354 0.532789 1.21573 0.465851 1.45411 0.505331Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M14.9657 11.0854C14.9657 10.8305 15.1725 10.6236 15.4273 10.6236H16.1509C16.4059 10.6236 16.6127 10.8304 16.6127 11.0854V11.809C16.6127 12.0638 16.4059 12.2708 16.1509 12.2708H15.4273C15.1725 12.2708 14.9657 12.0638 14.9657 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M12.0711 11.0854C12.0711 10.8305 12.278 10.6236 12.5329 10.6236H13.2564C13.5113 10.6236 13.7182 10.8304 13.7182 11.0854V11.809C13.7182 12.0638 13.5114 12.2708 13.2564 12.2708H12.5329C12.2779 12.2708 12.0711 12.0638 12.0711 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M12.0711 8.19138C12.0711 7.93656 12.2779 7.72959 12.5329 7.72959H13.2564C13.5114 7.72959 13.7182 7.93654 13.7182 8.19138V8.91494C13.7182 9.16977 13.5114 9.37673 13.2564 9.37673H12.5329C12.278 9.37673 12.0711 9.16978 12.0711 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M14.9657 8.19138C14.9657 7.93658 15.1724 7.72959 15.4273 7.72959H16.1509C16.4059 7.72959 16.6127 7.93654 16.6127 8.19138V8.91494C16.6127 9.16977 16.4059 9.37673 16.1509 9.37673H15.4273C15.1725 9.37673 14.9657 9.16976 14.9657 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M6.28306 11.0854C6.28306 10.8305 6.48987 10.6236 6.74485 10.6236H7.46841C7.72328 10.6236 7.93008 10.8305 7.93008 11.0854V11.809C7.93008 12.0638 7.72331 12.2708 7.46841 12.2708H6.74485C6.48986 12.2708 6.28306 12.0638 6.28306 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.3884 11.0854C3.3884 10.8305 3.59521 10.6236 3.8502 10.6236H4.57375C4.82858 10.6236 5.03555 10.8304 5.03555 11.0854V11.809C5.03555 12.0638 4.82861 12.2708 4.57375 12.2708H3.8502C3.59521 12.2708 3.3884 12.0638 3.3884 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.3884 8.19138C3.3884 7.93656 3.59519 7.72959 3.8502 7.72959H4.57375C4.8286 7.72959 5.03555 7.93652 5.03555 8.19138V8.91494C5.03555 9.16979 4.82861 9.37673 4.57375 9.37673H3.8502C3.59521 9.37673 3.3884 9.16978 3.3884 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M6.28306 8.19138C6.28306 7.93656 6.48985 7.72959 6.74485 7.72959H7.46841C7.7233 7.72959 7.93008 7.93657 7.93008 8.19138V8.91494C7.93008 9.16974 7.72331 9.37673 7.46841 9.37673H6.74485C6.48986 9.37673 6.28306 9.16978 6.28306 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M6.28306 5.29734C6.28306 5.04252 6.48985 4.83555 6.74485 4.83555H7.46841C7.7233 4.83555 7.93008 5.04252 7.93008 5.29734V6.0209C7.93008 6.27584 7.72329 6.48269 7.46841 6.48269H6.74485C6.48989 6.48269 6.28306 6.27588 6.28306 6.0209V5.29734Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.3884 5.29734C3.3884 5.04252 3.59519 4.83555 3.8502 4.83555H4.57375C4.8286 4.83555 5.03555 5.04248 5.03555 5.29734V6.0209C5.03555 6.27588 4.82859 6.48269 4.57375 6.48269H3.8502C3.59523 6.48269 3.3884 6.27588 3.3884 6.0209V5.29734Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                  </svg>
                )
              }

            </span>
            <p></p>
            <div className="flex flex-col">
              <span className="text-gray-900 text-base font-semibold">
                {title == "Clients" ? "Total Clients" : "Total Workers"}
              </span>
            </div>
          </div>
          <BtnLight className="w-20 h-9" onClick={() => title == "Clients" ? navigate(redirectPath) : navigate(redirectPath)}>View All</BtnLight>
        </div>
      </div>
      <div className="px-6">
        <DoughnutChart
          labels={ title == "Clients" ? ["Compliant", "Non-Compliant", "Invited"] : ["Compliant", "Non-Compliant", "Partial"]}
          type={title}
          chartData={title == "Clients" ?
            [Number(chartData?.compliant || 0), Number(chartData?.["non_compliant"] || 0), Number(chartData?.invited || 0)]
            : [Number(chartData?.compliant || 0), Number(chartData?.["non_compliant"] || 0),Number(chartData?.partial || 0)]
          }
        />
      </div>
    </Card>
  );
};
export default TotalClientAndWorker;
